import useLabels from "../customHooks/useLabels";

const useFormJson = () => {
  const {
    itemLabel,
    companyLabel,
    ledgerLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
  } = useLabels();
  const formJson = {
    JunctionsFormLabels: [
      {
        labelName: "Name",
        inputName: "name",
        dataType: "text",
        autoFocus: true,
        required: true,
      },
      {
        labelName: "Code",
        inputName: "code",
        dataType: "text",
        required: true,
      },
      {
        labelName: "Address",
        inputName: "address",
        dataType: "textarea",
      },
      {
        labelName: "City",
        inputName: "place",
        dataType: "city",
      },
      {
        labelName: "State",
        inputName: "state",
        dataType: "state",
      },
      {
        labelName: "Pin",
        inputName: "pin",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Country",
        inputName: "country",
        dataType: "country",
      },
      {
        labelName: `${ledgerLabel}`,
        inputName: "ldgrID",
        dataType: "ldgrID",
      },
      {
        labelName: "Priority",
        inputName: "priority",
        dataType: "priority",
      },
      {
        labelName: "Latitude",
        inputName: "latitude",
        dataType: "text",
      },
      {
        labelName: "Longitude",
        inputName: "longitude",
        dataType: "text",
      },
      {
        labelName: "Alias",
        inputName: "alias",
        dataType: "text",
      },
      {
        labelName: "Junction Type",
        inputName: "jType",
        dataType: "text",
      },
      {
        labelName: "Junction Status",
        inputName: "junctionStatus",
        dataType: "junctionStatus",
      },
      {
        labelName: "Comments",
        inputName: "remarks",
        dataType: "text",
      },
      {
        labelName: "Arms",
        inputName: "arms",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Number of Poles",
        inputName: "poles",
        dataType: "number",
        maxLength: 2,
      },
      {
        labelName: "Icon",
        inputName: "icon",
        dataType: "icon",
      },
    ],
    ItmsChallanFormLabels: [
       {
        labelName: "Challan Type",
        inputName: "challanType",
        dataType: "challanType",
        maxLength: 6,
      },
      {
        labelName: "Date",
        inputName: "date",
        dataType: "date",
        maxLength: 6,
      },
      {
        labelName: "Stop Line",
        inputName: "stopLine",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Seat Belt",
        inputName: "seatBelt",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Jumping Signal",
        inputName: "jumpingSignal",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Triple Ride",
        inputName: "tripleRide",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "No Helmet",
        inputName: "noHelmet",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Over Speed",
        inputName: "overSpeed",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Driver On Call",
        inputName: "driverOnCall",
        dataType: "number",
        maxLength: 6,
      },
    ],
    customerformLabels: {
      leftForm: [
        {
          labelName: "Name",
          inputName: "name",
          dataType: "text",
          autoFocus: true,
          required: true,
        },
        {
          labelName: "Address",
          inputName: "address",
          dataType: "textarea",
        },
        {
          labelName: "City",
          inputName: "place",
          dataType: "city",
        },
        {
          labelName: "State",
          inputName: "state",
          dataType: "state",
        },
        {
          labelName: "Pin",
          inputName: "pin",
          dataType: "number",
          maxLength: 6,
        },
        {
          labelName: "Country",
          inputName: "country",
          dataType: "country",
        },
        {
          labelName: "Contact Person",
          inputName: "contactPerson",
          dataType: "text",
        },
      ],
      rightForm: [
        {
          labelName: "Designation",
          inputName: "contactPersonDesign",
          dataType: "text",
        },
        {
          labelName: "Email",
          inputName: "email",
          dataType: "email",
          required: true,
        },
        {
          labelName: "Mobile",
          inputName: "mobile",
          dataType: "mobile",
          required: true,
        },
        {
          labelName: "Web Site",
          inputName: "url",
          dataType: "text",
        },
        {
          labelName: "PAN",
          inputName: "panNo",
          dataType: "text",
        },
        {
          labelName: "GST",
          inputName: "gstNo",
          dataType: "gstNo",
          maxLength: 13,
        },
      ],
    },
    userFormLabels: {
      leftForm: [
        {
          labelName: "Name",
          inputName: "name",
          dataType: "text",
          required: true,
        },

        {
          labelName: "Mobile",
          inputName: "mobile",
          dataType: "mobile",
          required: true,
        },
        {
          labelName: "Email",
          inputName: "email",
          dataType: "email",
        },
        {
          labelName: "Address",
          inputName: "address",
          dataType: "textarea",
        },
      ],
      rightForm: [
        {
          labelName: "Place",
          inputName: "place",
          dataType: "city",
        },
        {
          labelName: "State",
          inputName: "state",
          dataType: "state",
        },
        {
          labelName: "Pin",
          inputName: "pin",
          dataType: "number",
          maxLength: 6,
        },
      ],
    },

    companyFormLabels: {
      companyDetails: [
        {
          labelName: "Name",
          inputName: "name",
          dataType: "text",
          required: true,
          autoFocus: true,
        },
        {
          labelName: "Address",
          inputName: "address",
          dataType: "textarea",
          required: true,
        },
        {
          labelName: "City",
          inputName: "place",
          dataType: "city",
        },
        {
          labelName: "State",
          inputName: "state",
          dataType: "state",
        },
        {
          labelName: "Country",
          inputName: "country",
          dataType: "country",
        },
        {
          labelName: "Pin Code",
          inputName: "pin",
          dataType: "number",
          maxLength: 6,
        },
        {
          labelName: "Telephone",
          inputName: "telephone",
          dataType: "telephone",
        },
        {
          labelName: "Email",
          inputName: "email",
          dataType: "email",
        },
        {
          labelName: "Mobile No.",
          inputName: "mobile",
          dataType: "mobile",
          required: true,
          autoFocus: true,
        },
        {
          labelName: "Latitude.",
          inputName: "latitude",
          dataType: "latitude",
        },
        {
          labelName: "Longitude.",
          inputName: "longitude",
          dataType: "longitude",
        },
      ],
      contactDetails: [
        {
          labelName: "Name",
          inputName: "contactPerson",
          dataType: "text",
          required: true,
        },
        {
          labelName: "Designation",
          inputName: "contactPersonDesign",
          dataType: "text",
          required: true,
        },
        {
          labelName: "Email",
          inputName: "contactPersonEmail",
          dataType: "email",
          required: true,
        },
        {
          labelName: "Mobile No.",
          inputName: "contactPersonMobile",
          dataType: "mobile",
          required: true,
          prefix: "+91",
        },
        {
          labelName: `${companyLabel} Url`,
          inputName: "url",
          dataType: "url",
        },
      ],
      statuaryDetails: [
        {
          labelName: "Enable GST",
          inputName: "enableGst",
          dataType: "boolean",
          formFields: [
            {
              labelName: "State",
              inputName: "gstState",
              dataType: "state",
            },
            {
              labelName: "Registration Type",
              inputName: "regType",
              dataType: "regType",
            },
            {
              labelName: "GSTIN No.",
              inputName: "gstNo",
              dataType: "gstNo",
            },
            {
              labelName: "TAN  No.",
              inputName: "tanNo",
              dataType: "text",
            },
            {
              labelName: "PAN  No.",
              inputName: "panNo",
              dataType: "text",
            },
          ],
        },
        {
          labelName: "Enable TDS",
          inputName: "enableTds",
          dataType: "boolean",
        },
        {
          labelName: "Enable TCS",
          inputName: "enableTcs",
          dataType: "boolean",
        },
        {
          labelName: "Enabe Vat",
          inputName: "vatNo",
          dataType: "boolean",
        },
        {
          labelName: "Icon",
          inputName: "icon",
          dataType: "icon",
        },
      ],
    },
    SubsidiarySites: {
      companyDetails: [
        {
          labelName: "Name",
          inputName: "name",
          dataType: "text",
          autoFocus: true,
          required: true,
        },
        {
          labelName: "Email ID",
          inputName: "email",
          dataType: "email",
        },
        {
          labelName: "Mobile",
          inputName: "mobile",
          dataType: "mobile",
        },
        {
          labelName: "Address",
          inputName: "address",
          dataType: "textarea",
        },
        {
          labelName: "City",
          inputName: "place",
          dataType: "city",
        },
        {
          labelName: "State",
          inputName: "state",
          dataType: "state",
        },
        {
          labelName: "Pin",
          inputName: "pin",
          dataType: "number",
          maxLength: 6,
        },
        {
          labelName: "Country",
          inputName: "country",
          dataType: "country",
        },
        {
          labelName: "Latitude",
          inputName: "latitude",
          dataType: "latitude",
        },
        {
          labelName: "Longitude",
          inputName: "longitude",
          dataType: "longitude",
        },
        {
          labelName: "Icon",
          inputName: "icon",
          dataType: "icon",
        },
      ],
      contactDetails: [
        {
          labelName: "Contact Person",
          inputName: "contactPerson",
          dataType: "text",
        },
        {
          labelName: "Contact Person Designation",
          inputName: "contactPersonDesign",
          dataType: "text",
        },
        {
          labelName: "Contact Person Email",
          inputName: "contactPersonEmail",
          dataType: "email",
        },
        {
          labelName: "Contact Person Mobile",
          inputName: "contactPersonMobile",
          dataType: "mobile",
        },
      ],
    },

    UomFormLabels: [
      {
        labelName: "Uom",
        inputName: "uom",
        dataType: "uom",
        required: true,
        autoFocus: true,
      },
      {
        labelName: "Uom Description",
        inputName: "uomDesc",
        dataType: "uom_desc",
        required: true,
      },
      {
        labelName: "Decimals",
        inputName: "useDecimals",
        dataType: "boolean",
      },
      {
        labelName: "Decimal Nos",
        inputName: "decimalNos",
        dataType: "number",
      },
    ],
    ItemsForm: {
      descriptions: [
        {
          labelName: "Description",
          inputName: "desc",
          dataType: "string",
          required: true,
          autoFocus: true,
        },
        {
          labelName: "Code",
          inputName: "code",
          dataType: "string",
        },
        {
          labelName: "Enable GST",
          inputName: "enableGst",
          dataType: "boolean",
          formFields: [
            {
              labelName: "IGST",
              inputName: "igst",
              dataType: "number",
              maxLength: 2,
            },
            {
              labelName: "SGST",
              inputName: "sgst",
              dataType: "number",
              maxLength: 2,
            },
            {
              labelName: "CGST",
              inputName: "cgst",
              dataType: "number",
              maxLength: 2,
            },
            {
              labelName: "HSN Code",
              inputName: "hsnCode",
              dataType: "number",
              maxLength: 8,
            },
          ],
        },
        {
          labelName: `${itemLabel} Group`,
          inputName: "stckGroupID",
          dataType: "group",
        },
        {
          labelName: `${itemLabel} Category`,
          inputName: "stckCategoryID",
          dataType: "category",
        },
        {
          labelName: `${itemLabel} Manufacturer`,
          inputName: "stckManufacturerID",
          dataType: "manufacturer",
        },
        {
          labelName: "Unit of Measurment",
          inputName: "stckUomID",
          dataType: "uom",
        },
      ],
      configurations: [
        {
          labelName: "Type of Supply",
          inputName: "isStockOrService",
          dataType: "stock_service",
        },
        {
          labelName: "Track Serial",
          inputName: "trackSerial",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Batch",
          inputName: "trackBatch",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Brand",
          inputName: "trackBrand",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Model",
          inputName: "trackModel",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Expiry",
          inputName: "trackExpiry",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Warranty",
          inputName: "trackWarranty",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Installation",
          inputName: "trackInstallation",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Maintenance",
          inputName: "trackMaintenance",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Calibration",
          inputName: "trackCalibration",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Perishable",
          inputName: "isPerishable",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Consumable",
          inputName: "isConsumable",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Image Needed",
          inputName: "imageNeeded",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track AMC",
          inputName: "trackAmc",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Geo Location",
          inputName: "trackGeoLocation",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Track Insurance",
          inputName: "trackInsurance",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Is Module",
          inputName: "isModule",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Is Component",
          inputName: "isComponent",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Image Path",
          inputName: "image_path",
          dataType: "file",
          required: false,
        },
        {
          labelName: "Additional Property Needed",
          inputName: "additionalPropertyNeeded",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Select icon",
          inputName: "icon",
          dataType: "icon",
          required: false,
        },
      ],
    },
    supplierDetails: {
      details: [
        {
          labelName: `${ledgerLabel} Name`,
          inputName: "supplier_name",
          dataType: "text",
          autoFocus: true,
          required: true,
        },
        {
          labelName: "Address",
          inputName: "address",
          dataType: "textarea",
        },
        {
          labelName: "City",
          inputName: "city",
          dataType: "city",
        },
        {
          labelName: "State",
          inputName: "state",
          dataType: "state",
          required: true,
        },
        {
          labelName: "Pin Code",
          inputName: "pin",
          dataType: "string",
          maxLength: 6,
        },
        {
          labelName: "Country",
          inputName: "country",
          dataType: "country",
          required: true,
        },
        {
          labelName: "Mobile No.",
          inputName: "phone",
          dataType: "mobile",
          required: true,
        },
        {
          labelName: "Email",
          inputName: "email",
          dataType: "email",
          required: true,
        },
      ],
      multiLocation: [
        {
          labelName: "Multiple Location Available",
          inputName: "multi_location",
          dataType: "boolean",
          required: false,
        },
        {
          labelName: "Include Device Type",
          inputName: "includeDeviceType",
          dataType: "boolean",
          required: false,
        },
      ],
      contactFields: [
        {
          labelName: "Name",
          inputName: "contactPerson",
          dataType: "string",
          required: true,
        },
        {
          labelName: "Address",
          inputName: "contactPersonAddress",
          dataType: "textarea",
          required: false,
        },
        {
          labelName: "City",
          inputName: "contactPersonCity",
          dataType: "city",
          required: false,
        },
        {
          labelName: "State",
          inputName: "contactPersonState",
          dataType: "state",
          required: false,
        },
        {
          labelName: "Pin Code",
          inputName: "contactPersonPin",
          dataType: "number",
          required: false,
          maxLength: 6,
        },
        {
          labelName: "Country",
          inputName: "contactPersonCountry",
          dataType: "country",
          required: false,
        },
        {
          labelName: "Mobile",
          inputName: "contactPersonMobile",
          dataType: "mobile",
          required: true,
        },
        {
          labelName: "Email",
          inputName: "contactPersonEmail",
          dataType: "email",
          required: true,
        },
        {
          labelName: "Aadhar No",
          inputName: "contactPersonAadhar",
          dataType: "string",
          required: false,
        },
      ],
    },
    supplierRequiredDetails: {
      requiredDetails: [
        {
          labelName: "GST Number",
          inputName: "gstNo",
          dataType: "string",
          autoFocus: true,
          required: false,
        },
        {
          labelName: "TAN Number",
          inputName: "tanNo",
          dataType: "string",
          required: false,
        },
        {
          labelName: "PAN Number",
          inputName: "panNo",
          dataType: "string",
          required: false,
        },
        {
          labelName: "VAT Number",
          inputName: "vatNo",
          dataType: "text",
          required: false,
        },
        {
          labelName: "Bank Account Number",
          inputName: "bankAcNo",
          dataType: "string",
          required: true,
        },
        {
          labelName: "Bank Name",
          inputName: "bankName",
          dataType: "string",
          required: true,
        },
        {
          labelName: "Bank Branch",
          inputName: "bankBranch",
          dataType: "string",
          required: true,
        },
        {
          labelName: "Bank IFSC Code",
          inputName: "bankIfsc",
          dataType: "string",
          required: true,
        },
        {
          labelName: "Bank MICR Code",
          inputName: "bankMicr",
          dataType: "string",
          required: false,
        },
        {
          labelName: "Proficiency",
          inputName: "proficiency",
          dataType: "string",
          required: false,
        },
      ],
      AltContactPerson: [
        {
          labelName: "Alternate Contact Person",
          inputName: "alterContactPerson",
          dataType: "string",
          required: false,
        },
        {
          labelName: "Alternate Contact Person Mobile",
          inputName: "alterContactPersonMobile",
          dataType: "mobile",
          required: false,
        },
        {
          labelName: "Alternate Contact Person Email",
          inputName: "alterContactPersonEmail",
          dataType: "email",
          required: false,
        },
        {
          labelName: "Aadhar No",
          inputName: "alterContactPersonAadhar",
          dataType: "string",
          required: false,
        },
      ],
    },

    multiLocation: [
      {
        labelName: "Address",
        inputName: "address",
        dataType: "textarea",
        required: true,
        autoFocus: true,
      },
      {
        labelName: "City",
        inputName: "city",
        dataType: "city",
      },
      {
        labelName: "Pin Code",
        inputName: "pin",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "State",
        inputName: "state",
        dataType: "state",
      },
      {
        labelName: "Country",
        inputName: "country",
        dataType: "country",
      },
      {
        labelName: "Email",
        inputName: "email",
        dataType: "email",
      },
      {
        labelName: "Phone",
        inputName: "phone",
        dataType: "mobile",
      },
      {
        labelName: "GST No",
        inputName: "gstNo",
        dataType: "text",
      },
      {
        labelName: "TAN No",
        inputName: "tanNo",
        dataType: "text",
      },
      {
        labelName: "VAT No",
        inputName: "vatNo",
        dataType: "text",
      },
      {
        labelName: "PAN No",
        inputName: "panNo",
        dataType: "text",
      },
      {
        labelName: "Contact Name",
        inputName: "contactPerson",
        dataType: "text",
      },
      {
        labelName: "Contact Person Address",
        inputName: "contactPersonAddress",
        dataType: "text",
      },
      {
        labelName: "Contact Person City",
        inputName: "contactPersonCity",
        dataType: "city",
      },
      {
        labelName: "Contact Person Pin",
        inputName: "contactPersonPin",
        dataType: "number",
        maxLength: 6,
      },
      {
        labelName: "Contact Person State",
        inputName: "contactPersonState",
        dataType: "state",
      },
      {
        labelName: "Contact Person Country",
        inputName: "contactPersonCountry",
        dataType: "country",
      },
      {
        labelName: "Contact Person Email",
        inputName: "contactPersonEmail",
        dataType: "email",
      },
      {
        labelName: "Contact Person Mobile",
        inputName: "contactPersonMobile",
        dataType: "mobile",
      },
      {
        labelName: "Contact Person Aadhar",
        inputName: "contactPersonAadhar",
        dataType: "number",
      },
    ],
    ProjectDetails: {
      left: [
        {
          labelName: "Project name",
          inputName: "name",
          dataType: "text",
          autoFocus: true,
          required: true,
        },
        {
          labelName: "Work Order No",
          inputName: "workOrderNum",
          dataType: "text",
          required: true,
        },
        {
          labelName: "Project Scope",
          inputName: "projectScope",
          dataType: "textarea",
          required: false,
        },
        {
          labelName: "Letter of Acceptance Date",
          inputName: "loa",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Go Live Date",
          inputName: "goLiveDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Agreement Date",
          inputName: "agreementDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Project Start Date",
          inputName: "startDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Project End Date",
          inputName: "endDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Insurance Start Date",
          inputName: "insuranceStartDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Insurance End Date",
          inputName: "insuranceEndDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Contract Signed With",
          inputName: "contractSignedWith",
          dataType: "text",
          required: false,
        },
        {
          labelName: "Contract Value / Budget",
          inputName: "contractValue",
          dataType: "number",
          required: false,
        },
      ],
      right: [
        {
          labelName: "AMC Start Date",
          inputName: "amcStartDate",
          dataType: "date",
          required: false,
        },

        {
          labelName: "AMC Insurance Start Date",
          inputName: "amcInsuranceStartDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "AMC Insurance End Date",
          inputName: "amcInsuranceEndDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "AMC Scope",
          inputName: "amcScope",
          dataType: "textarea",
          required: false,
        },
        {
          labelName: "SLA Billing Cycle",
          inputName: "slaBillingCycle",
          dataType: "text",
          required: false,
        },
        {
          labelName: "Bank Guarantee",
          inputName: "bgValue",
          dataType: "text",
          required: false,
        },

        {
          labelName: "Bank Guarantee Start Date",
          inputName: "bgStartDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Bank Guarantee End Date",
          inputName: "bgEndDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Defect Libility Period Start Date",
          inputName: "dlpStartDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Defect Libility Period End Date",
          inputName: "dlpEndDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Upload Agreement",
          inputName: "agreementFile",
          dataType: "file",
          required: false,
          disabled: true,
        },
        {
          labelName: "Upload End of Agreement",
          inputName: "endAgreementFile",
          dataType: "file",
          required: false,
          disabled: true,
        },
         {
          labelName: "Is Meeting Active",
          inputName: "isMeetingActive",
          dataType: "boolean",
          required: false,
          disabled: false,
        },
      ],
    },

    ProjectExtDetails: {
      left: [
        {
          labelName: "Project name",
          inputName: "name",
          dataType: "text",
          autoFocus: true,
          required: true,
        },
        {
          labelName: "Project Scope",
          inputName: "projectScope",
          dataType: "textarea",
          required: false,
        },
        {
          labelName: "Letter of Acceptance Date",
          inputName: "loa",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Agreement Date",
          inputName: "agreementDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Project Start Date",
          inputName: "startDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Project End Date",
          inputName: "endDate",
          dataType: "date",
          required: false,
        },
        {
          labelName: "Contract Signed With",
          inputName: "contractSignedWith",
          dataType: "text",
          required: false,
        },
      ],
      right: [
        {
          labelName: "Upload Agreement",
          inputName: "agreementFile",
          dataType: "file",
          required: false,
          disabled: true,
        },
        {
          labelName: "Upload End of Agreement",
          inputName: "endAgreementFile",
          dataType: "file",
          required: false,
          disabled: true,
        },
      ],
    },
    viewMaterialRequestOrder: {
      leftForm: [
        {
          labelName: "Material Request No.",
          inputName: "mrfNo",
          dataType: "text",
        },
        {
          labelName: "Material Request For",
          inputName: "materialReqFor",
          dataType: "text",
        },
        {
          labelName: "Reference No.",
          inputName: "refNo",
          dataType: "text",
        },
      ],
    },
    Quotation: {
      Preview: [
        {
          labelName: "Last Date for Submission",
          inputName: "place",
          dataType: "date",
        },
        {
          labelName: "GST No",
          inputName: "gstNo",
          dataType: "text",
        },
        {
          labelName: `${companyLabel} Name`,
          inputName: "company_name",
          dataType: "text",
        },
        {
          labelName: "Requested Quotation No.",
          inputName: "requested_quotation_no",
          dataType: "text",
        },
        {
          labelName: "PAN  No.",
          inputName: "pan_no",
          dataType: "text",
        },
        {
          labelName: "City",
          inputName: "place",
          dataType: "text",
        },
        {
          labelName: "Narration",
          inputName: "narration",
          dataType: "textarea",
        },
      ],
      FillItem: {
        ItemDetails: [
          {
            labelName: `${itemLabel} Description (RFQ Description)`,
            inputName: "item_desc",
            dataType: "textarea",
          },
          {
            labelName: "Required Qty",
            inputName: "required_qty",
            dataType: "text",
          },
          {
            labelName: "Terms",
            inputName: "terms",
            dataType: "textarea",
          },
          {
            labelName: "Payment Terms",
            inputName: "payment_terms",
            dataType: "textarea",
          },
        ],
        QuotationDetails: [
          {
            labelName: "Interested to Quote",
            inputName: "interested_to_quote",
            dataType: "interested_to_quote",
          },
          {
            labelName: "Change in desc (Yes/No)",
            inputName: "change_in_desc",
            dataType: "change_in_desc",
          },
          {
            labelName: "Enter New Description",
            inputName: "description",
            dataType: "description",
          },
          {
            labelName: "Quoted Qty",
            inputName: "quoted_qty",
            dataType: "text",
          },
          {
            labelName: "Rate",
            inputName: "rate",
            dataType: "rate",
          },
          {
            labelName: "Any other Charges per Qty",
            inputName: "any_other_charges",
            dataType: "any_other_charges",
          },

          {
            labelName: "Taxes %",
            inputName: "tax_perc",
            dataType: "text",
          },
          {
            labelName: "Total Amount",
            inputName: "total_amount",
            dataType: "total_amount",
          },
          {
            labelName: "Delivery Charges",
            inputName: "delivery_charges",
            dataType: "delivery_charges",
          },
          {
            labelName: "Installation Charges",
            inputName: "installation_charges",
            dataType: "installation_charges",
          },
          {
            labelName: "Net Quoted",
            inputName: "net_quoted",
            dataType: "net_quoted",
          },
          {
            labelName: "Remarks",
            inputName: "remarks",
            dataType: "textarea",
          },
        ],
        SupplierTerms: {
          GeneralTerms: [
            {
              labelName: "Our General Terms",
              inputName: "our_general_terms",
              dataType: "textarea",
            },
            {
              labelName: "Our general Payment Terms",
              inputName: "general_payment_terms",
              dataType: "textarea",
            },
          ],
          Terms: [
            {
              labelName: "Date",
              inputName: "date",
              dataType: "date",
            },
            {
              labelName: "your General Terms",
              inputName: "your_general_terms",
              dataType: "textarea",
            },
            {
              labelName: "Your general Payment Terms",
              inputName: "your_general_payment_terms",
              dataType: "textarea",
            },
            {
              labelName: "Narration",
              inputName: "narration",
              dataType: "textarea",
            },
          ],
        },
      },
    },
    Purchase: {
      Conclude: [
        {
          labelName: "Unit of Measurement Description",
          inputName: "uom_desc",
        },
        {
          labelName: "UOM",
          inputName: "uom",
        },
        {
          labelName: "Description Sent on RFQ",
          inputName: "rfq",
        },
        {
          labelName: "Present Stock",
          inputName: "present_stock",
        },
        {
          labelName: "Required Qty",
          inputName: "required_qty",
        },
        {
          labelName: "Approx Rate",
          inputName: "approx_rate",
        },
        {
          labelName: "Taxable Value",
          inputName: "taxable_name",
        },
        {
          labelName: "Tax %",
          inputName: "tax",
        },
        {
          labelName: "Net Value",
          inputName: "net_name",
        },
        {
          labelName: "Priority",
          inputName: "priority",
        },
        {
          labelName: "Need before",
          inputName: "need_before",
        },
        {
          labelName: `Prefered ${ledgerLabel}`,
          inputName: "prefered_vendor",
        },
        {
          labelName: "Used For",
          inputName: "used_for",
        },
        {
          labelName: "Remark",
          inputName: "remark",
        },
      ],
      AddItem: [
        {
          labelName: `${itemLabel} Code/Name`,
          inputName: "item_code",
        },
        {
          labelName: "HSN Code",
          inputName: "hsn_code",
          disabled: true,
        },
        {
          labelName: "UOM",
          inputName: "uom",
          disabled: true,
        },
        {
          labelName: "Rate",
          inputName: "rate",
        },
        {
          labelName: "Quantity",
          inputName: "qty",
        },
        {
          labelName: "Pr Disc %",
          inputName: "pr_disc_perc",
        },

        {
          labelName: "Prm Disc Amount",
          inputName: "prm_discount_amt",
          disabled: true,
        },
        {
          labelName: "Taxable Value",
          inputName: "taxable_value",
          disabled: true,
        },
        {
          labelName: "IGST",
          inputName: "igst",
        },
        {
          labelName: "SGST",
          inputName: "sgst",
        },
        {
          labelName: "CGST",
          inputName: "cgst",
        },
        {
          labelName: "Tax Amount",
          inputName: "tax_amount",
          disabled: true,
        },
        {
          labelName: "Delivery Charges",
          inputName: "delivery_charges",
        },
        {
          labelName: "Installation Charges",
          inputName: "installation_charges",
        },
        {
          labelName: "Net Value",
          disabled: true,
          inputName: "net_value",
        },
      ],
    },
    Masters: {
      Items: [
        {
          labelName: "Track Serial No.",
          inputName: "track_serial_no",
          componentType: "Toggle",
        },
        {
          labelName: "Track Branch",
          inputName: "track_branch",
          componentType: "Toggle",
        },
        {
          labelName: "Track Expiry",
          inputName: "track_expiry",
          componentType: "Toggle",
        },
        {
          labelName: "Track Warranty",
          inputName: "track_warranty",
          componentType: "Toggle",
        },
        {
          labelName: "Track Installation",
          inputName: "track_installation",
          componentType: "Toggle",
        },
        {
          labelName: "Track Maintenance",
          inputName: "track_maintenance",
          componentType: "Toggle",
        },
        {
          labelName: "Is Perishable",
          inputName: "is_perishable",
          componentType: "Toggle",
        },
        {
          labelName: "Is Consumable",
          inputName: "is_consumable",
          componentType: "Toggle",
        },
        {
          labelName: "Is Goods",
          inputName: "is_goods",
          componentType: "Toggle",
        },
        {
          labelName: "Is Services",
          inputName: "is_services",
          componentType: "Toggle",
        },
        {
          labelName: "AMC Needed",
          inputName: "amc_needed",
          componentType: "Toggle",
        },
        {
          labelName: "Geo Location Needed",
          inputName: "geo_location_needed",
          componentType: "Toggle",
        },
        {
          labelName: "Insurance Needed",
          inputName: "insurance_needed",
          componentType: "Toggle",
        },
        {
          labelName: "Is Module",
          inputName: "is_module",
          componentType: "Toggle",
        },
        {
          labelName: "Is Component",
          inputName: "is_component",
          componentType: "Toggle",
        },
        {
          labelName: "Image Needed",
          inputName: "image_needed",
          componentType: "Toggle",
        },
      ],
      Supplier: {
        Flags: [
          {
            labelName: "GSTIN No.",
            inputName: "gstin_no",
          },
          {
            labelName: "TAN  No.",
            inputName: "tan_no",
          },
          {
            labelName: "PAN  No.",
            inputName: "pan_no",
          },
          {
            labelName: "Bank A/C No.",
            inputName: "bank_ac_no",
          },
          {
            labelName: "Bank",
            inputName: "bank",
          },
          {
            labelName: "Branch",
            inputName: "branch",
          },
          {
            labelName: "IFSC Code",
            inputName: "ifsc_code",
          },
          {
            labelName: "MICR Code",
            inputName: "micr_code",
          },
          {
            labelName: "Proficiency",
            inputName: "micr_code",
          },
        ],
        BasicDetails: {
          Supplier: [
            {
              labelName: "City",
              inputName: "city",
            },
            {
              labelName: "State",
              inputName: "state",
            },
            {
              labelName: "Pin-Code",
              inputName: "pin",
            },
            {
              labelName: "Country",
              inputName: "country",
            },
            {
              labelName: "Mobile",
              inputName: "phone",
            },
            {
              labelName: "Email",
              inputName: "email",
            },
            {
              labelName: "Aadhar Id No.",
              inputName: "contactPersonAadhar",
            },
          ],
          ContactPersonDetails: [
            {
              labelName: "City",
              inputName: "contactPersonCity",
            },
            {
              labelName: "State",
              inputName: "contactPersonState",
            },
            {
              labelName: "Pin-Code",
              inputName: "contactPersonPin",
            },
            {
              labelName: "Country",
              inputName: "contactPersonCountry",
            },
            {
              labelName: "Mobile",
              inputName: "contactPersonMobile",
            },
            {
              labelName: "Email",
              inputName: "contactPersonEmail",
            },
          ],
        },
        RequiredDetails: {
          Details: [
            {
              labelName: "GSTIN No.",
              inputName: "gstNo",
            },
            {
              labelName: "TAN  no.",
              inputName: "tanNo",
            },
            {
              labelName: "PAN  no.",
              inputName: "panNo",
            },
            {
              labelName: "Bank A/C No.",
              inputName: "bankAcNo",
            },
            {
              labelName: "Bank",
              inputName: "bankName",
            },
            {
              labelName: "Branch",
              inputName: "bankBranch",
            },
            {
              labelName: "IFSC Code",
              inputName: "bankIfsc",
            },
            {
              labelName: "MICR Code",
              inputName: "bankMicr",
            },
            {
              labelName: "Proficiency",
              inputName: "proficiency",
            },
          ],
          AlternateContactPersonDetails: [
            {
              labelName: "Alternate Contact Person Name",
              inputName: "alterContactPerson",
            },
            {
              labelName: "Mobile",
              inputName: "alterContactPersonMobile",
            },
            {
              labelName: "Email",
              inputName: "alterContactPersonEmail",
            },
            {
              labelName: "Aadhar ID No.",
              inputName: "alterContactPersonAadhar",
            },
          ],
        },
      },
      Configurations: [
        {
          labelName: "Configuration Form",
          inputName: "module",
        },
        {
          labelName: "Enter Configuration Caption",
          inputName: "formLabelCaption",
        },
        {
          labelName: "Table Header",
          inputName: "tableHeader",
        },
        {
          labelName: "Component Type",
          inputName: "component_type",
        },
        {
          labelName: "Data Type",
          inputName: "dataStorageType",
        },
      ],
      ItemConfigurations: [
        {
          labelName: "Enter Table Header",
          inputName: "AdditionalPropertyDesc",
        },
        {
          labelName: "Data Type",
          inputName: "AdditionalPropertyDatatype",
        },
      ],
      ItemDetails: [
        {
          labelName: `${itemLabel} Description`,
          inputName: "item_description",
          componentType: "Text",
        },
        {
          labelName: `${itemLabel} Code`,
          inputName: "item_code",
          componentType: "Text",
        },
        {
          labelName: "GST Applicable",
          inputName: "gst_applicable",
          componentType: "Select",
        },
        {
          labelName: `${itemLabel} Category`,
          inputName: "item_category",
          componentType: "Select",
        },
        {
          labelName: "Unit of Measurment",
          inputName: "uom",
          componentType: "Select",
        },
        {
          labelName: "Track Serial No.",
          inputName: "track_serial_no",
          componentType: "Toggle",
        },
        {
          labelName: "Track Branch",
          inputName: "track_branch",
          componentType: "Toggle",
        },
        {
          labelName: "Track Expiry",
          inputName: "track_expiry",
          componentType: "Toggle",
        },
        {
          labelName: "Track Warranty",
          inputName: "track_warranty",
          componentType: "Toggle",
        },
        {
          labelName: "Track Installation",
          inputName: "track_installation",
          componentType: "Toggle",
        },
        {
          labelName: "Track Maintenance",
          inputName: "track_maintenance",
          componentType: "Toggle",
        },
        {
          labelName: "Is Perishable",
          inputName: "is_perishable",
          componentType: "Toggle",
        },
        {
          labelName: "Is Consumable",
          inputName: "is_consumable",
          componentType: "Toggle",
        },
        {
          labelName: "Is Goods",
          inputName: "is_goods",
          componentType: "Toggle",
        },
        {
          labelName: "Is Services",
          inputName: "is_services",
          componentType: "Toggle",
        },
        {
          labelName: "AMC Needed",
          inputName: "amc_needed",
          componentType: "Toggle",
        },
        {
          labelName: "Geo Location Needed",
          inputName: "geo_location_needed",
          componentType: "Toggle",
        },
        {
          labelName: "Insurance Needed",
          inputName: "insurance_needed",
          componentType: "Toggle",
        },
        {
          labelName: "Is Module",
          inputName: "is_module",
          componentType: "Toggle",
        },
        {
          labelName: "Is Component",
          inputName: "is_component",
          componentType: "Toggle",
        },
        {
          labelName: "Image Needed",
          inputName: "image_needed",
          componentType: "Toggle",
        },
      ],
      Edit: [
        {
          labelName: "Enter New Input Label",
          inputName: "enter_new_input",
        },
        {
          labelName: "Existing Input Label",
          inputName: "existing_input",
          disabled: true,
        },
        {
          labelName: "data type",
          inputName: "data_type",
          disabled: true,
        },
      ],
    },
    PurchaseForm: {
      Conclude: [
        {
          labelName: "Unit of Measurement Description",
          inputName: "uom_desc",
        },
        {
          labelName: "UOM",
          inputName: "uom",
        },
        {
          labelName: "Description Sent on RFQ",
          inputName: "udfItemDesc",
        },
        {
          labelName: "Present Stock",
          inputName: "present_stock",
        },
        {
          labelName: "Required Qty",
          inputName: "required_qty",
        },
        {
          labelName: "Approx Rate",
          inputName: "approx_rate",
        },
        {
          labelName: "Taxable Value",
          inputName: "taxable_value",
        },
        {
          labelName: "Tax %",
          inputName: "tax",
        },
        {
          labelName: "Net Value",
          inputName: "net_value",
        },
        {
          labelName: "Priority",
          inputName: "priority",
        },
        {
          labelName: "Need before",
          inputName: "need_before",
        },
        {
          labelName: `Prefered ${ledgerLabel}`,
          inputName: "prefered_vendor",
        },
        {
          labelName: "Used For",
          inputName: "used_for",
        },
        {
          labelName: "Remark",
          inputName: "remark",
        },
      ],
    },
    FillNegotiationDetails: {
      ItemDetails: [
        {
          labelName: `${itemLabel} Description (RFQ Description)`,
          inputName: "item_desc",
        },
        {
          labelName: "Required Qty",
          inputName: "required_qty",
        },
        {
          labelName: "Terms",
          inputName: "terms",
        },
        {
          labelName: "Payment Terms",
          inputName: "payment_terms",
        },
      ],
      VendorQuotedDetails: [
        {
          labelName: `Quoted ${companyLabel}`,
          inputName: "quoted_company",
        },
        {
          labelName: `${ledgerLabel} ${itemLabel} Description`,
          inputName: "vendor_item_desc",
        },
        {
          labelName: "Quoted Qty",
          inputName: "quoted_qty",
        },
        {
          labelName: "Rate",
          inputName: "rate",
        },
        {
          inputName: "any_other_charges",
          labelName: "Any other Charges per Qty",
        },
        {
          labelName: "Tax %",
          inputName: "tax_perc",
        },
        {
          labelName: "Total Amount",
          inputName: "total_amount",
        },
        {
          labelName: "Others",
          inputName: "others",
        },
        {
          labelName: "Net Quoted",
          inputName: "net_quoted",
        },
        {
          labelName: "Remarks",
          inputName: "remarks",
        },
      ],
      NegotiationDetails: [
        {
          labelName: "Place Order",
          inputName: "negoStatus",
        },
        {
          labelName: "Verbal Final Rate",
          inputName: "negoRate",
          dataType: "number",
        },
        {
          labelName: "Quantity",
          inputName: "negoQty",
          dataType: "number",
        },
        {
          labelName: "Others",
          inputName: "negoOther",
          dataType: "number",
        },
        {
          labelName: "Taxable",
          inputName: "negoTaxable",
          dataType: "number",
        },
        {
          labelName: "Taxes",
          inputName: "negoTax",
          dataType: "number",
        },
        {
          labelName: "Delivery charges",
          inputName: "negoDelvChrg",
          dataType: "number",
        },
        {
          labelName: "Instant charges",
          inputName: "negoInstChrg",
          dataType: "number",
        },
        {
          labelName: "Verbal Final Amount",
          inputName: "negoValue",
          dataType: "number",
        },
        {
          labelName: "Remarks",
          inputName: "negoRemarks",
          dataType: "textarea",
        },

        {
          labelName: "Negotiation By",
          inputName: "negotiation_by",
        },
      ],
    },
    Material: {
      AddItem: {
        leftForm: [
          {
            labelName: `${itemLabel} Description`,
            inputName: "itm_desc",
            dataType: "items",
          },
          {
            labelName: "Description for RFQ",
            inputName: "udfItemDesc",
            dataType: "textarea",
            rows: 3,
          },
          {
            labelName: "UOM",
            inputName: "uom",
            dataType: "input",
            disabled: true,
          },
          {
            labelName: "Present Stock",
            inputName: "presentStk",
            dataType: "number",
          },
          {
            labelName: "Required Qty",
            inputName: "reqQty",
            dataType: "number",
            required: true,
          },
          {
            labelName: "Approx Rate",
            inputName: "approxRate",
            dataType: "number",
          },
          {
            labelName: "Delivery Rate",
            inputName: "deliveryRate",
            dataType: "number",
          },
          {
            labelName: "Installation Rate",
            inputName: "installationRate",
            dataType: "number",
          },
          {
            labelName: "Others Rate",
            inputName: "otherRate",
            dataType: "number",
          },
          {
            labelName: "Approx Taxable Value",
            inputName: "approxTaxableValue",
            dataType: "number",
            disabled: true,
            className: "itm_approx_tax",
          },
          {
            labelName: "Tax %",
            inputName: "tax",
            dataType: "number",
          },
          {
            labelName: "Taxes",
            inputName: "taxedValue",
            dataType: "number",
            className: "itm_taxes",
          },
          {
            labelName: "Approx Value",
            inputName: "approxValue",
            dataType: "number",
            className: "itm_approx_value",
          },
        ],
        rightForm: [
          {
            labelName: "Need Before",
            inputName: "trnNeedBefore",
            dataType: "date",
          },
          {
            labelName: "Priority",
            inputName: "priority",
            dataType: "priority",
          },
          {
            labelName: `Preferred ${ledgerLabel}`,
            inputName: "preferrefVendor",
            dataType: "preferrefVendor",
          },
          {
            labelName: "Used For",
            inputName: "usedFor",
            dataType: "textarea",
            rows: 3,
          },
          {
            labelName: "Remarks",
            inputName: "remarks",
            dataType: "textarea",
            rows: 3,
          },
        ],
      },
    },
    RFQPOAdd: {
      AddItem: {
        leftForm: [
          {
            labelName: "RFQ",
            inputName: "rfq",
            dataType: "rfqs",
          },
          {
            labelName: "RFQ Date",
            inputName: "rfqDate",
            dataType: "date",
            disabled: true,
          },
          {
            labelName: `${itemLabel}`,
            inputName: "item",
            dataType: "items",
          },
          {
            labelName: `${itemLabel} UOM`,
            inputName: "itemUom",
            dataType: "text",
            disabled: true,
          },
          {
            labelName: "Quantity",
            inputName: "itemQty",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Rate",
            inputName: "itemRate",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Other Charges",
            inputName: "itemOther",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Taxable Rate",
            inputName: "itemTaxable",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Tax %",
            inputName: "itemTax",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Installation Rate",
            inputName: "itemInstChrg",
            dataType: "number",
            disabled: true,
          },
        ],
        rightForm: [
          {
            labelName: "Delivery Charges",
            inputName: "itemDelvChrg",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Delivery Date",
            inputName: "itemDeliveryDate",
            dataType: "date",
          },
          {
            labelName: "NET Total",
            inputName: "netTotal",
            dataType: "number",
            disabled: true,
          },
        ],
      },
    },
    MRFPOAdd: {
      AddItem: {
        leftForm: [
          {
            labelName: "MRF",
            inputName: "mrf",
            dataType: "mrfs",
          },
          {
            labelName: "MRF Date",
            inputName: "mrfDate",
            dataType: "date",
            disabled: true,
          },
          {
            labelName: `${itemLabel}`,
            inputName: "item",
            dataType: "items",
          },
          {
            labelName: `${itemLabel} UOM`,
            inputName: "itemUom",
            dataType: "text",
            disabled: true,
          },
          {
            labelName: "Quantity",
            inputName: "itemQty",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Rate",
            inputName: "itemRate",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Other Charges",
            inputName: "itemOther",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Taxable Rate",
            inputName: "itemTaxable",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Tax %",
            inputName: "itemTax",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Installation Rate",
            inputName: "itemInstChrg",
            dataType: "number",
            disabled: true,
          },
        ],
        rightForm: [
          {
            labelName: "Delivery Charges",
            inputName: "itemDelvChrg",
            dataType: "number",
            disabled: true,
          },
          {
            labelName: "Delivery Date",
            inputName: "itemDeliveryDate",
            dataType: "date",
          },
          {
            labelName: "NET Total",
            inputName: "netTotal",
            dataType: "number",
            disabled: true,
          },
        ],
      },
    },
    MRFtoPOEntry: {
      ItemDetails: [
        {
          labelName: `${itemLabel} Description`,
          inputName: "item_desc",
          className: "",
        },
        {
          labelName: "Description for RFQ",
          inputName: "desc_for_rfq",
        },
        {
          labelName: "UOM",
          inputName: "uom",
        },
        {
          labelName: "Present Stock",
          inputName: "present_stock",
        },
        {
          labelName: "Req Qty",
          inputName: "req_qty",
        },
        {
          labelName: "Approx Rate",
          inputName: "approx_rate",
        },
        {
          labelName: "Delivery Rate",
          inputName: "delivery_rate",
        },
        {
          labelName: "Installation Rate",
          inputName: "installation_rate",
        },
        { labelName: "Others Rate", inputName: "others_rate" },
        {
          labelName: "Approx Taxable Value",
          inputName: "approx_taxable_value",
          className: "font-green",
        },
        {
          labelName: "Taxes %",
          inputName: "taxes",
          className: "bg-red",
        },
        {
          labelName: "Approx Value",
          inputName: "approx_value",
          className: "bg-green",
        },
        {
          labelName: "Need Before",
          inputName: "need_before",
          dataType: "date",
        },
        {
          labelName: "Priority",
          inputName: "priority",
          className: "font-green",
        },
        {
          labelName: `Prefered ${ledgerLabel}`,
          inputName: "prefered_vendor",
        },
        {
          labelName: "Used For",
          inputName: "used_for",
        },
        {
          labelName: "Remarks",
          inputName: "remarks",
        },
      ],
      AcceptedDetails: [
        {
          labelName: "Accepted",
          inputName: "accepted",
        },
        {
          labelName: "Accepted Qty",
          inputName: "accepted_qty",
          className: "font-amber",
        },
        {
          labelName: "Approx Value",
          inputName: "approx_value",
          className: "font-green",
        },
        { labelName: "Remarks", inputName: "remarks" },
      ],
      LastOrderedDetails: [
        {
          labelName: "Last Supplied By",
          inputName: "last_supplied_by",
        },
        {
          labelName: "Last Supplied Qty",
          inputName: "last_supplied_qty",
          className: "font-amber",
        },
        {
          labelName: "Last Supplied Rate",
          inputName: "last_supplied_rate",
          className: "font-green",
        },
      ],
      ConfirmOrder: [
        {
          labelName: `Order ${ledgerLabel} To`,
          inputName: "order_supplier_to",
        },
        {
          labelName: "Ordered Rate",
          inputName: "ordered_rate",
        },
        {
          labelName: "Remarks",
          inputName: "remarks",
        },
      ],
    },
    ItemObForm: {
      ObDetails: [
        {
          labelName: "Code",
          inputName: "code",
        },
        {
          labelName: "Description",
          inputName: "description",
        },
        {
          labelName: "UOM",
          inputName: "uom",
        },
        {
          labelName: "Category",
          inputName: "category",
        },
        {
          labelName: "Sub-Category",
          inputName: "sub_category",
        },
        {
          labelName: "Manufacturer",
          inputName: "manufacturer",
        },
        {
          labelName: "Model",
          inputName: "model",
        },
        {
          labelName: "HSN Code",
          inputName: "hsn_code",
        },
        {
          labelName: "IGST Rate %",
          inputName: "igst_rate",
        },
        {
          labelName: "CGST %",
          inputName: "cgst_rate",
        },
        {
          labelName: "SGST %",
          inputName: "sgst_rate",
        },
      ],
    },
    StockEntry: {
      WithoutPurchase: {
        ItemDetails: [
          {
            labelName: "Code",
            inputName: "code",
          },
          {
            labelName: "Description",
            inputName: "description",
          },
          {
            labelName: "Uom",
            inputName: "uom",
          },
          {
            labelName: "Category",
            inputName: "category",
          },
          {
            labelName: "Sub-Category",
            inputName: "sub_category",
          },
          {
            labelName: "Manufacturer",
            inputName: "manufacturer",
          },
        ],
        SupplierDetails: [
          {
            labelName: ledgerLabel,
            inputName: "supplier",
          },
          {
            labelName: `${ledgerLabel} Reference No.`,
            inputName: "supplier_ref_no",
          },
          {
            labelName: "Supplied Date",
            inputName: "supplied_date",
          },
          {
            labelName: "Supplied Qty",
            inputName: "supplied_qty",
          },
          {
            labelName: "Supplied Rate",
            inputName: "supplied_rate",
          },
        ],
        ViewAsset: [
          {
            labelName: "Description",
            inputName: "description",
          },
          {
            labelName: "Code",
            inputName: "code",
          },
          {
            labelName: "GST Applicable",
            inputName: "gst_applicable",
          },
          {
            labelName: "Category",
            inputName: "category",
          },
          {
            labelName: "Sub-Category",
            inputName: "sub_category",
          },
          {
            labelName: "Unit of Measurment",
            inputName: "uom",
          },
          {
            labelName: "Model",
            inputName: "model",
          },
        ],
      },
    },
    StockBalance: {
      Add: [
        {
          labelName: "Code",
          inputName: "code",
        },
        {
          labelName: "Description",
          inputName: "description",
        },
        {
          labelName: "UOM",
          inputName: "uom",
        },
        {
          labelName: "Category",
          inputName: "category",
        },
        {
          labelName: "Sub-Category",
          inputName: "sub_category",
        },
        {
          labelName: "Manufacturer",
          inputName: "manufacturer",
        },
        {
          labelName: "Model",
          inputName: "model",
        },
        {
          labelName: "HSN Code",
          inputName: "hsn_code",
        },
        {
          labelName: "IGST Rate %",
          inputName: "igst_rate",
        },
        {
          labelName: "CGST Rate %",
          inputName: "cgst_rate",
        },
        {
          labelName: "SGST %",
          inputName: "sgst_rate",
        },
      ],
    },
    Maps: {
      AssetDetails: [
        { labelName: "Code", inputName: "code", disabled: true },
        { labelName: "Serial No.", inputName: "serial_no", disabled: true },
        { labelName: "Batch", inputName: "batch", disabled: true },
        {
          labelName: "Expiry",
          inputName: "expiry",
          disabled: true,
          dataType: "date",
        },
        {
          labelName: "Warranty Start Date",
          inputName: "s_date",
          disabled: true,
          dataType: "date",
        },
        {
          labelName: "Warranty End Date",
          inputName: "e_date",
          disabled: true,
          dataType: "date",
        },
        {
          labelName: "Maintained By",
          inputName: "maintained_by",
          disabled: true,
        },
        {
          labelName: "Geo Location",
          inputName: "geo_location",
          disabled: true,
        },
        {
          labelName: `${itemLabel} Location`,
          inputName: "asset_location",
          disabled: true,
        },
        {
          labelName: "Installation Date&Time",
          inputName: "installation_date",
          disabled: true,
          dataType: "date",
        },
      ],
      RaiseTicket: [
        {
          labelName: `Pole Number`,
          inputName: "pole_number",
          disabled: true,
        },
        {
          labelName: `Choose ${itemLabel}`,
          inputName: "choose_asset",
        },
        { labelName: "Ticket Reason", inputName: "reason" },
        { labelName: "Remarks", inputName: "remarks" },
      ],
    },
    ItemDetailsFormLabels: {
      leftForm: [
        {
          labelName: "Name",
          inputName: "itemDesc",
          dataType: "text",
          disabled: true,
        },
        {
          labelName: "Alias",
          inputName: "alias",
          dataType: "text",
          // required: true,
        },
        {
          labelName: "Address",
          inputName: "address",
          dataType: "text",
        },
        {
          labelName: "Batch Number",
          inputName: "prodBatchNo",
          dataType: "text",
        },
        {
          labelName: "Product Serial Number",
          inputName: "prodSerialNo",
          dataType: "text",
        },
        {
          labelName: "Batch Number",
          inputName: "prodBatchNo",
          dataType: "text",
        },
        {
          labelName: "Model",
          inputName: "prodModel",
          dataType: "text",
        },
        {
          labelName: "Maintained By",
          inputName: "ldgrID",
          dataType: "text",
        },
        {
          labelName: "Expiry Date",
          inputName: "prodExpiryDate",
          dataType: "date",
        },
        {
          labelName: "Warranty Start Date",
          inputName: "prodWarrantyStartDate",
          dataType: "date",
        },
        {
          labelName: "Warranty End Date",
          inputName: "prodWarrantyEndDate",
          dataType: "date",
        },
        {
          labelName: "Installation End Date",
          inputName: "prodInstallationEndDate",
          dataType: "date",
        },
        {
          labelName: "AmcStDate",
          inputName: "prodAmcStDate",
          dataType: "date",
        },
        {
          labelName: "AmcEndDate",
          inputName: "prodAmcEndDate",
          dataType: "date",
        },
        {
          labelName: "Insurance Start Date",
          inputName: "prodInsuranceStDate",
          dataType: "date",
        },
        {
          labelName: "Insurance End Date",
          inputName: "prodInsuranceEndDate",
          dataType: "date",
        },
        {
          labelName: "Latitude",
          inputName: "prodLatitude",
          dataType: "text",
        },
        {
          labelName: "Longitude",
          inputName: "prodLongitude",
          dataType: "text",
        },
      ],
      rightForm: [
        {
          labelName: "Property Data 1",
          inputName: "propertyData1",
          dataType: "text",
        },
        {
          labelName: "Property Data 2",
          inputName: "propertyData2",
          dataType: "text",
        },
        {
          labelName: "Property Data 3",
          inputName: "propertyData3",
          dataType: "text",
        },
        {
          labelName: "Property Data 4",
          inputName: "propertyData4",
          dataType: "text",
        },
        {
          labelName: "Property Data 5",
          inputName: "propertyData5",
          dataType: "text",
        },
        {
          labelName: "Property Data 6",
          inputName: "propertyData6",
          dataType: "text",
        },
        {
          labelName: "Property Data 7",
          inputName: "propertyData7",
          dataType: "text",
        },
        {
          labelName: "Property Data 8",
          inputName: "propertyData8",
          dataType: "text",
        },
        {
          labelName: "Property Data 9",
          inputName: "propertyData9",
          dataType: "text",
        },
        {
          labelName: "Property Data 10",
          inputName: "propertyData10",
          dataType: "text",
        },
      ],
    },
    FillWorkProgress: [
      {
        labelName: "Today",
        inputName: "today",
        dataType: "date",
        disabled: true,
      },
      {
        labelName: "Quality",
        inputName: "quality",
        dataType: "text",
        disabled: true,
      },
      {
        labelName: "Foundation Completed",
        inputName: "foundation_completed",
        dataType: "text",
      },
      {
        labelName: "IT Hardware Installation",
        inputName: "it_hw_installation",
        dataType: "text",
      },
      {
        labelName: "Pending Work",
        inputName: "pending_work",
        dataType: "text",
      },
      {
        labelName: "Completed & Go-Live",
        inputName: "complteted",
        dataType: "text",
      },
      {
        labelName: "Remarks",
        inputName: "remarks",
        dataType: "text",
      },
    ],
  };
  return formJson;
};

export default useFormJson;
